import { render, staticRenderFns } from "./PageBottomContent.vue?vue&type=template&id=4f5f8de4&scoped=true&"
import script from "./PageBottomContent.vue?vue&type=script&lang=ts&"
export * from "./PageBottomContent.vue?vue&type=script&lang=ts&"
import style0 from "./PageBottomContent.vue?vue&type=style&index=0&id=4f5f8de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f8de4",
  null
  
)

export default component.exports